export interface BaseTableColumns {
    id: number;
    sender: string;
    service: string;
    client: string;
    date: string;
}

export class EmployeeTableColumns implements BaseTableColumns {
    constructor(public id: number, public sender: string, public service: string, public client: string, public date: string) {}
}
export class EmployeeTableclosedDateColumns implements BaseTableColumns {
    constructor(public id: number, public sender: string, public service: string, public client: string, public date: string, public closedDate?: string) {}
}